export const ImpetusBrandMark = ({
  className = "brand-mark",
}: Readonly<{ className?: string }>) => (
  <svg viewBox="0 0 36 36" aria-hidden="true" className={className}>
    <path d="M27.7 7.3C18.1 7.8 10.2 12.5 8.5 20c-1 4.4 1.6 8 5.7 8.6 7.2 1 12.7-6.6 13.5-21.3Z" />
    <path d="M8.6 28.5c3.7-5.7 8.2-9.9 14.4-13" />
  </svg>
)
